export const CancellationInitialValues = {
  createdAt: new Date(),
  observations: '',
  userId: '',
  canceledId: '',
}

